import type { UsageData, GpuQuotaWindow } from "@/hooks/useUserUsage";

export type UsageLevel = "low" | "moderate" | "high" | "critical";

export function gpuWindowPct(w: GpuQuotaWindow | undefined): number {
  if (!w || w.limit <= 0) return 0;
  return (w.used / w.limit) * 100;
}

export function getUsagePercentage(data: UsageData): number {
  const hourly = data.usage.hour;
  const queuePct = hourly.limit === null ? 0 : (hourly.used / hourly.limit) * 100;

  const gpuPcts = [
    gpuWindowPct(data.gpuQuota?.fourHour),
    gpuWindowPct(data.gpuQuota?.sevenDay),
    gpuWindowPct(data.gpuQuota?.monthly),
  ];

  return Math.min(Math.max(queuePct, ...gpuPcts), 200);
}

export function getUsageLevel(data: UsageData): { level: UsageLevel; percentage: number } {
  const pct = getUsagePercentage(data);
  if (pct > 90) return { level: "critical", percentage: pct };
  if (pct > 75) return { level: "high", percentage: pct };
  if (pct > 50) return { level: "moderate", percentage: pct };
  return { level: "low", percentage: pct };
}

export function getStatusColor(pct: number, tier?: string): string {
  if (pct > 90) return "text-red-400";
  if (pct > 75) return "text-orange-400";
  if (pct > 50) return "text-yellow-400";
  if (tier === "starter") return "text-yellow-400";
  return "text-[hsl(var(--brand-violet-500))]";
}
